 /* ===========================================================
 * 
 *   Cookiebar Controller
 * 
 *   Managed the cookiebar popup that appears on first
 *   site visit
 * 
 *   Requires: jQuery
 * 
 * ===========================================================*/


$(function() {

    var cookiebar = $('.js__cookiebar');
    var dismissbutton = $('.js__cookiebar-dismiss');

    /**
	 * Create a cookie
     * 
     * @param {string} name
     * @param {mixed} value
     * @param {string} days
     * 
	 */
    var createCookie = function( name, value, days ) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            var expires = "; expires="+date.toGMTString();
        }
        else var expires = "";
        document.cookie = name+"="+value+expires+"; path=/";
    }
    
    /**
	 * Read a cookie
     * 
     * @param {string} name
     * 
	 */
    var readCookie = function( name ) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    

    /**
     * Add key listeners to the cookiebar dismiss link
     */
    var triggerCookiebarDismiss = function( e ) {
        
        if(e.which == 13) {
            e.preventDefault();
            e.stopPropagation();
            dismissbutton.trigger('click');
        }

        if(e.which == 32) {
            e.preventDefault();
            e.stopPropagation();
            dismissbutton.trigger('click');
        }
    }


    /**
     * Add padding to the body of the page if the cookie bar is active
     * This prevents the cookie bar from overlapping the footer
     */
    var cookiebarPadding = function() {
        if (cookiebar.length) {
            if (cookiebar.css('display') == 'block') {
                cookiebarHeight = cookiebar.outerHeight();
                $('body').css('padding-bottom', cookiebarHeight);
                return;
            }
        }

        $('body').css('padding-bottom', 0);
    }


    /**
	 * Init the listeners
	 */
    var init = function(){

        if (val = readCookie('cookiebar-dismissed')) {
            if (val == 'true' || val == true || val == 1) {
                return;
            }
        }

        //  Show the cookiebar
        cookiebar.show();

        //  Add key listeners to the cookiebar dismiss link
        //dismissbutton.on('keyup', triggerCookiebarDismiss );

        //  Resize the window so the cookiebar can fit below the footer
        $(window).on('resize', cookiebarPadding);
        
        //  Add the dismiss action
        $(document).on('click touchstart', '.js__cookiebar-dismiss', function(){
            createCookie('cookiebar-dismissed', true, 365);
            cookiebar.hide();
            cookiebarPadding();
        })

        cookiebarPadding();

    }

    //  Do it
    init();
});
